<mat-dialog-content>
  <div id="w3l-appointment">
    <div class="wrapper">
    <div class="d-grid doctor-appointment">
      <form action="#" method="post" >

          <div class="appointment-form-field">
              <label style="width: 50px;font-weight: bold;">{{ 'Line' | translate }}</label>
              <label style="width: 20px;"></label>
              <label style="width: 100px;font-weight: bold;">{{ 'Item Code' | translate }}</label>
              <label style="width: 50px;"></label>
              <label style="width: 250px;font-weight: bold;">{{ 'Item Name' | translate }}</label>
              <label style="width: 20px;"></label>
              <label style="width: 100px;font-weight: bold;">{{ 'QTY' | translate }}</label>
              <label style="width: 20px;"></label>
              <label style="width: 100px;font-weight: bold;">{{ 'Price' | translate }}</label>
              <label style="width: 20px;"></label>
              <label style="width: 100px;font-weight: bold;">{{ 'Value' | translate }}</label>
              <label style="width: 20px;"></label>
              <label style="width: 100px;font-weight: bold;">{{ 'Notes' | translate }}</label>

          </div>
          <div class="appointment-form-field">
            <label id="w3l-appointment" class="appointment-form-field" style="width: 50px;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{detline}}</label>
            <label style="width: 20px;"></label>
            <input type="text" name="expcode"  required="" style="width: 100px;" [(ngModel)]="detitem" (change)="RetriveItems()">
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="OpenDialogItem()"></span>
            <input type="text" name="textname"  required="" style="width: 250px;" [(ngModel)]="detitemname" disabled="true">
            <label style="width: 20px;"></label>
            <input type="number" name="textqty"  required="" style="width: 100px;" [(ngModel)]="detqty" (change)="GetValue()">
            <label style="width: 20px;"></label>
            <input type="number" name="textprice"  required="" style="width: 100px;" [(ngModel)]="detprice" (change)="GetValue()">
            <label style="width: 20px;"></label>
            <label id="w3l-appointment" class="appointment-form-field" style="width: 100px;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{detvalue |  number:'1.2-2'}}</label>
            <label style="width: 20px;"></label>
            <input type="text" name="textnots"  required="" style="width: 200px;" [(ngModel)]="detdescription">

        </div>
      </form>
    </div>
    </div>
  </div>

                <BR>
                <BR>
              <div style="text-align: center; ">
                  <button type="button" class="theme-button btn" name="submit"  (click)="submitLine()" >Submit</button>
                  <button type="button" class="theme-button btn" name="Delete" (click)="mesgDelete()"  >Delete</button>
                  <button type="button" class="theme-button btn" name="New" (click)="CloseDialog()">Close</button>
              </div>

  </mat-dialog-content>


